export default __webpack_public_path__ + "assets/_Chapters/_Images/background/Klaus-Kroschke-Gruppe/2.jpg";